var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('button',{class:[_vm.variant, _vm.variant === 'flat' ? 'p2-style' : 'h4-style', _vm.size],attrs:{"disabled":_vm.disabled,"type":_vm.type},on:{"click":function($event){return _vm.emitClick()}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }